<template>
	<page>
		<module :title="verify ? '发放任务审核' : '发放任务详情'">
			<div v-if="taskInfo">
				<c-detail title="基础信息">
					<c-detail-item label="任务类型" full>
                        <span v-if="taskInfo.task_type == 0" style="color:darkcyan">自动发放</span>
                        <span v-if="taskInfo.task_type == 1" style="color:darkgoldenrod">自行领券</span>
                    </c-detail-item>
					<c-detail-item label="任务名称" full>{{taskInfo.task_name}}</c-detail-item>
                    <c-detail-item label="指定用户" full  v-if="taskInfo.task_user_type==0">
                        <span style="color:#999">全部用户</span>
                    </c-detail-item>
                    <c-detail-item label="指定用户" full v-if="taskInfo.task_user_type==2">
						<c-table :data="memberList" v-if="taskInfo.task_user_type==2" height="auto" border :paging="false" style="width:1000px;">
							<c-table-column
								label="手机号-用户名"
								name="user_manage_mobilephone"
								width="300"
							>
								<template v-slot="row">
									{{row.data.user_manage_mobilephone}}
									<span v-if="row.data.login_name">-{{row.data.login_name}}</span>
								</template>
							</c-table-column>
							
							<c-table-column
								label="昵称"
								name="nick_name"
								width="200"
							></c-table-column>
						</c-table>
					</c-detail-item>
				</c-detail>
				
				<c-detail title="发放策略">
					<c-detail-item label="优惠券" full>
						<c-table :data="couponList" height="auto" border :paging="false" style="width:1000px;">
							<c-table-column
								label="优惠券名称"
								name="coupon_name"
								width="120"
							></c-table-column>
							
							<c-table-column
								label="优惠力度"
								name="detail"
								width="120"
							></c-table-column>
							
							<c-table-column
								label="适用范围"
								name="commodity_range"
								width="70"
							>
								<template v-slot="{data}">
									{{dict.couponRange[data.commodity_range]}}
								</template>
							</c-table-column>
							
							<c-table-column
								label="剩余可领"
								name="surplus"
								width="70"
							></c-table-column>
							
							<c-table-column
								required
								label="有效期"
								width="310"
							>
								<template v-slot="row">
									<span v-if="row.data.valid_date_type" style="margin-right: 5px;">{{row.data.valid_date_type == 1 ? `${row.data.valid_start_date} - ${row.data.valid_end_date}` : `领取后${row.data.effective_days}天内`}}</span>
								</template>
							
							</c-table-column>
							
							<c-table-column
								label="每人限领"
								width="80"
								name="received_count"
							></c-table-column>
							
							<c-table-column
								label="券标签"
								width="80"
								name="coupon_tag"
							></c-table-column>
						</c-table>
					</c-detail-item>
					<c-detail-item label="发放时间" full v-if="taskInfo.task_user_type==2">{{taskInfo.execute_type == 1 ? '立即发放' : taskInfo.scheduled_execute_date}}</c-detail-item>
					<c-detail-item label="备注" full>{{taskInfo.remark}}</c-detail-item>
				</c-detail>
			</div>
			
			<template v-if="verify" slot="button">
				<c-button color="main" size="form" @click="verifyHandle(2)">审核通过</c-button>
				<c-button size="form" color="red" @click="verifyHandle(-1)">审核驳回</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'coupon_task_detail',
		
		props: {
			id: String,
			
			verify: Boolean
		},
		
		data() {
			return {
				taskInfo: '',
				memberList: [],
				couponList: []
			}
		},
		
		computed: {
			...mapState(['dict'])
		},
		
		watch: {
			id() {
				this.getTaskDetail();
			}
		},
		
		mounted() {
			this.getTaskDetail();
		},
		
		methods: {
			getTaskDetail() {
				this.request({
					url: '/couponInfo/task/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.taskInfo = data;
						this.memberList = data.user_list || [];
						this.couponList = data.coupon_list || [];
					}
				});
			},
			
			verifyHandle(state) {
				this.request({
					url: '/couponInfo/task/approval',
					data: {
						id: this.id,
						state
					},
					loading: true,
					success: () => {
						this.$message({
							type:'success',
							message: '审核成功'
						});
						this.navigateTo('/coupon?tab=1');
					}
				});
			}
		}
	}
</script>